/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Associatedcompany201,
  PostApiV1Associatedcompany400,
  PostApiV1Associatedcompany401,
  PostApiV1Associatedcompany500,
  PostApiV1AssociatedcompanyMutationRequest,
  PostApiV1AssociatedcompanyMutationResponse,
} from "../../types/associatedCompanyController/PostApiV1Associatedcompany.ts";
import { associatedCompanyDetailViewModelSchema } from "../associatedCompanyDetailViewModelSchema.ts";
import { associatedCompanyEditorViewModelSchema } from "../associatedCompanyEditorViewModelSchema.ts";

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1Associatedcompany201Schema = z.lazy(
  () => associatedCompanyDetailViewModelSchema,
) as unknown as ToZod<PostApiV1Associatedcompany201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Associatedcompany400Schema =
  z.any() as unknown as ToZod<PostApiV1Associatedcompany400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Associatedcompany401Schema =
  z.any() as unknown as ToZod<PostApiV1Associatedcompany401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Associatedcompany500Schema =
  z.any() as unknown as ToZod<PostApiV1Associatedcompany500>;

export const postApiV1AssociatedcompanyMutationRequestSchema = z.lazy(
  () => associatedCompanyEditorViewModelSchema,
) as unknown as ToZod<PostApiV1AssociatedcompanyMutationRequest>;

export const postApiV1AssociatedcompanyMutationResponseSchema = z.lazy(
  () => postApiV1Associatedcompany201Schema,
) as unknown as ToZod<PostApiV1AssociatedcompanyMutationResponse>;
